


































































import { Vue, Component, Prop } from "vue-property-decorator";
import { IEventable } from '@/loader';
import EventableEdit from "../../../component/EventableEdit.vue";
import dayjs from 'dayjs';

@Component({
	components: {
		EventableEdit,
	},
})
export default class UploadFileModal extends Vue {
	@Prop({ type: String, default: "upload_modal" })
	public id!: string;

	@Prop({ type: Object, default: null })
	public item!: IEventable;

	@Prop({ type: String, default: "" })
	public accept!: string;

	@Prop({ type: String, default: "md" })
	public size!: string;

	@Prop({ type: Boolean, default: false })
	public preview!: boolean;

	@Prop({ type: Boolean, default: false })
	public showDate!: boolean;

	@Prop({ type: String, default: () => dayjs().format("YYYY-MM-DD") })
	public date!: string;

	public file: File | null = null;
	public content: string | ArrayBuffer = "";

	public get localDate(): string {
		return this.date;
	}
	public set localDate(value: string) {
		this.$emit("change-date", value);
	}

	public get isPDF(): boolean {
		return this.file?.type === "application/pdf";
	}

	public get isImage(): boolean {
		return this.file?.type.startsWith("image/") || false;
	}

	public getFileContent(file: File) {
		let reader = new FileReader();
		reader.onload = e => {
			this.content = e.target?.result || "";
		};
		reader.readAsDataURL(file);
	}
}
